import { Point } from '../../../../../../FrontendBundle/Resources/js/ofcs';

/**
 * Intersection points collection. Holds all points of a collision.
 * Collection will only add unique points.
 *
 *     var intersection = new Intersections();
 *     intersection.add(new Point(1,2));
 *     console.log(intersection.count());
 *     var points = intersection.get();
 *
 * @class Intersections
 */
export default class Intersections {
    points = [];
    hashes = {};

    /**
     * Add an Ofcs.Point to intersection collection.
     *
     * @param {Point} point Intersection point
     * @return {Intersections}
     * @chainable
     */
    add(point) {
        if (!(point instanceof Point)) {
            throw new Error('Parameter must be instance of Point');
        }

        const hash = `${point.x}_${point.y}`;

        if (this.hashes[hash]) {
            return this;
        }

        this.points.push(point);
        this.hashes[hash] = 1;

        return this;
    }

    /**
     * Return points of collection
     *
     * @return {Point[]}
     */
    get() {
        return this.points;
    }

    /**
     * Return number of points in collection
     *
     * @return {number}
     */
    count() {
        return this.points.length;
    }

    /**
     * Iterate over all points in collection
     *
     * @param {Function} callback
     * @param {Object} scope
     */
    each(callback, scope) {
        this.points.forEach(callback, scope);
    }

    showVisual(canvas) {
        this.points.forEach((point) => {
            canvas.getSvgWrapper().circle(
                canvas.getLayerManager().getElement('collisions'),
                point.x,
                point.y,
                2,
                {
                    stroke: 'orange',
                    fill: 'yellow',
                },
            );
        });
    }
}
